/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

// Composables
import { createVuetify } from "vuetify";

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  defaults: {
    VCard: {
      class: "pa-3 rounded-xl elevation-5",
    },
    VTextField: {
      baseColor: "primary",
      color: "primary",
      variant: "outlined",
    },
    VCombobox: {
      baseColor: "primary",
      color: "primary",
      variant: "outlined",
    },
  },
  theme: {
    variations: {
      colors: ["primary", "secondary"],
      lighten: 3,
      darken: 3,
    },
    themes: {
      light: {
        colors: {
          primary: "#03045E",
          secondary: "#0077B6",
          error: "#cc0000",
          defaultBg: "#f1f5f9",
          slightBlue: "#eff6ff",
          progress: "#03045E",
          bw: "#FFF",
          wb: "#000",
        },
      },
      dark: {
        colors: {
          primary: "#03045E",
          secondary: "#0077B6",
          error: "#cc0000",
          defaultBg: "#020617",
          slightBlue: "#172554",
          progress: "#0077B6",
          bw: "#000",
          wb: "#FFF",
        },
      },
    },
  },
});
